import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enPickup from './locales/en/pickup.json';
import esCommon from './locales/es/common.json';
import esPickup from './locales/es/pickup.json';
import frCommon from './locales/fr-CA/common.json';
import frPickup from './locales/fr-CA/pickup.json';
import enLocation from './locales/en/location.json';
import esLocation from './locales/es/location.json';
import frLocation from './locales/fr-CA/location.json';
import enComplete from './locales/en/complete.json';
import esComplete from './locales/es/complete.json';
import frComplete from './locales/fr-CA/complete.json';
import enCashReady from './locales/en/cashReady.json';
import esCashReady from './locales/es/cashReady.json';
import frCashReady from './locales/fr-CA/cashReady.json';
import enAmountAvailable from './locales/en/amountAvailable.json';
import esAmountAvailable from './locales/es/amountAvailable.json';
import frAmountAvailable from './locales/fr-CA/amountAvailable.json';
import enLogin from './locales/en/login.json';
import esLogin from './locales/es/login.json';
import frLogin from './locales/fr-CA/login.json';
import enLoginOtp from './locales/en/enterLoginOtp.json';
import esLoginOtp from './locales/es/enterLoginOtp.json';
import frLoginOtp from './locales/fr-CA/enterLoginOtp.json';
import enEnterOtp from './locales/en/enterOtp.json';
import esEnterOtp from './locales/es/enterOtp.json';
import frEnterOtp from './locales/fr-CA/enterOtp.json';
import enForgotPassword from './locales/en/forgotPassword.json';
import esForgotPassword from './locales/es/forgotPassword.json';
import frForgotPassword from './locales/fr-CA/forgotPassword.json';
import enHistory from './locales/en/history.json';
import esHistory from './locales/es/history.json';
import frHistory from './locales/fr-CA/history.json';
import enLanding from './locales/en/landing.json';
import esLanding from './locales/es/landing.json';
import frLanding from './locales/fr-CA/landing.json';
import enPagination from './locales/en/pagination.json';
import esPagination from './locales/es/pagination.json';
import frPagination from './locales/fr-CA/pagination.json';
import enNotFound from './locales/en/notFound.json';
import esNotFound from './locales/es/notFound.json';
import frNotFound from './locales/fr-CA/notFound.json';
import enDisplay from './locales/en/display.json';
import esDisplay from './locales/es/display.json';
import frDisplay from './locales/fr-CA/display.json';
import enCard from './locales/en/card.json';
import esCard from './locales/es/card.json';
import frCard from './locales/fr-CA/card.json';
import enCommunication from './locales/en/communication.json';
import esCommunication from './locales/es/communication.json';
import frCommunication from './locales/fr-CA/communication.json';
import enNetwork from './locales/en/network.json';
import esNetwork from './locales/es/network.json';
import frNetwork from './locales/fr-CA/network.json';
import enPaymentChoice from './locales/en/paymentChoice.json';
import esPaymentChoice from './locales/es/paymentChoice.json';
import frPaymentChoice from './locales/fr-CA/paymentChoice.json';
import enSecurity from './locales/en/security.json';
import esSecurity from './locales/es/security.json';
import frSecurity from './locales/fr-CA/security.json';
import enSetup1 from './locales/en/setup1.json';
import esSetup1 from './locales/es/setup1.json';
import frSetup1 from './locales/fr-CA/setup1.json';
import enSetup from './locales/en/setup2.json';
import esSetup from './locales/es/setup2.json';
import frSetup from './locales/fr-CA/setup2.json';
import enSetup3a from './locales/en/setup3a.json';
import esSetup3a from './locales/es/setup3a.json';
import frSetup3a from './locales/fr-CA/setup3a.json';
import enSetup3b from './locales/en/setup3b.json';
import esSetup3b from './locales/es/setup3b.json';
import frSetup3b from './locales/fr-CA/setup3b.json';
import enSetup4 from './locales/en/setup4.json';
import esSetup4 from './locales/es/setup4.json';
import frSetup4 from './locales/fr-CA/setup4.json';
import enSignup from './locales/en/signup.json';
import esSignup from './locales/es/signup.json';
import frSignup from './locales/fr-CA/signup.json';
import enSignupFlow from './locales/en/setupFlow.json';
import esSignupFlow from './locales/es/setupFlow.json';
import frSignupFlow from './locales/fr-CA/setupFlow.json';
import enSignupVerify from './locales/en/signupVerify.json';
import esSignupVerify from './locales/es/signupVerify.json';
import frSignupVerify from './locales/fr-CA/signupVerify.json';
import enSpareWelcome from './locales/en/spareWelcome.json';
import esSpareWelcome from './locales/es/spareWelcome.json';
import frSpareWelcome from './locales/fr-CA/spareWelcome.json';
import enHeader from './locales/en/header.json';
import esHeader from './locales/es/header.json';
import frHeader from './locales/fr-CA/header.json';
import enDisplayMain from './locales/en/displayMain.json';
import esDisplayMain from './locales/es/displayMain.json';
import frDisplayMain from './locales/fr-CA/displayMain.json';
import { displayName } from 'react-quill';

i18n
  .use(initReactI18next)
  .init({
    lng: (() => {
      try { return localStorage.getItem('lng') || 'en'; } catch (e) { return 'en'; }
    })(),
    fallbackLng: 'en',
    debug: false,
    interpolation: { escapeValue: false },

    // Make sure "location" is listed here
    ns: ['common', 'pickup', 'location', 'complete', 'cashReady', 
          'amountAvailable', 'login', 'loginOtp', 'enterOtp', 'forgotPassword', 
          'history', 'landing', 'pagination', 'notFound', 'display', 'card', 
          'communication', 'network','paymentChoice', 'security', 
          'setup1', 'setup', 'setup3a', 'setup3b', 'setup4',
          'signup', 'signupFlow', 'signupVerify', 'spareWelcome',
          'header', 'displayMain'],
    defaultNS: 'common',

    resources: {
      en: {
        common: enCommon,
        pickup: enPickup,
        location: enLocation,
        complete: enComplete,
        cashReady: enCashReady,
        amountAvailable: enAmountAvailable,
        login: enLogin,
        loginOtp: enLoginOtp,
        enterOtp: enEnterOtp,
        forgotPassword: enForgotPassword,
        history: enHistory,
        landing: enLanding,
        pagination: enPagination,
        notFound: enNotFound,
        display: enDisplay,
        card: enCard,
        communication: enCommunication,
        network: enNetwork,
        paymentChoice: enPaymentChoice,
        security: enSecurity,
        setup1: enSetup1,
        setup: enSetup,
        setup3a: enSetup3a,
        setup3b: enSetup3b,
        setup4: enSetup4,
        signup: enSignup,
        signupFlow: enSignupFlow,
        signupVerify: enSignupVerify,
        spareWelcome: enSpareWelcome,
        header: enHeader,
        displayMain: enDisplayMain
      },
      es: {
        common: esCommon,
        pickup: esPickup,
        location: esLocation,
        complete: esComplete,
        cashReady: esCashReady,
        amountAvailable: esAmountAvailable,
        login: esLogin,
        loginOtp: esLoginOtp,
        enterOtp: esEnterOtp,
        forgotPassword: esForgotPassword,
        history: esHistory,
        landing: esLanding,
        pagination: esPagination,
        notFound: esNotFound,
        display: esDisplay,
        card: esCard,
        communication: esCommunication,
        network: esNetwork,
        paymentChoice: esPaymentChoice,
        security: esSecurity,
        setup1: esSetup1,
        setup: esSetup,
        setup3a: esSetup3a,
        setup3b: esSetup3b,
        setup4: esSetup4,
        signup: esSignup,
        signupFlow: esSignupFlow,
        signupVerify: esSignupVerify,
        spareWelcome: esSpareWelcome,
        header: esHeader,
        displayMain: esDisplayMain
      },
      'fr-CA': {
        common: frCommon,
        pickup: frPickup,
        location: frLocation,
        complete: frComplete,
        cashReady: frCashReady,
        amountAvailable: frAmountAvailable,
        login: frLogin,
        loginOtp: frLoginOtp,
        enterOtp: frEnterOtp,
        forgotPassword: frForgotPassword,
        history: frHistory,
        landing: frLanding,
        pagination: frPagination,
        notFound: frNotFound,
        display: frDisplay,
        card: frCard,
        communication: frCommunication,
        network: frNetwork,
        paymentChoice: frPaymentChoice,
        security: frSecurity,
        setup1: frSetup1,
        setup: frSetup,
        setup3a: frSetup3a,
        setup3b: frSetup3b,
        setup4: frSetup4,
        signup: frSignup,
        signupFlow: frSignupFlow,
        signupVerify: frSignupVerify,
        spareWelcome: frSpareWelcome,
        header: frHeader,
        displayMain: frDisplayMain
      }
    },

    react: { useSuspense: false }
  });

// expose for quick console testing: i18n.changeLanguage('es')
window.i18n = i18n;

export default i18n;
